import React from 'react'
import { Text } from '../../../new/core-components'
import { ConfirmationModalProps } from '../types'
import { BaseModalLayout } from '../BaseModalLayout'

export const ConfirmationModal = ({
  title,
  description,
  variant = 'error',
  onCancel,
  onConfirm,
  ...rest
}: ConfirmationModalProps) => (
  <BaseModalLayout
    withDivider
    header={
      <Text textStyle='page-heading' m={0}>
        {title}
      </Text>
    }
    variant={variant}
    onClose={() => {
      onCancel()
    }}
    onCancelClick={onCancel}
    onConfirmClick={onConfirm}
    {...rest}
  >
    <Text textStyle='item-unselected' color='text/body-moderate'>
      {description}
    </Text>
  </BaseModalLayout>
)
